import { render, staticRenderFns } from "./technicalQuality.vue?vue&type=template&id=a1cc13a6&scoped=true"
import script from "./technicalQuality.vue?vue&type=script&lang=js"
export * from "./technicalQuality.vue?vue&type=script&lang=js"
import style0 from "./technicalQuality.vue?vue&type=style&index=0&id=a1cc13a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cc13a6",
  null
  
)

export default component.exports